// extracted by mini-css-extract-plugin
export default {"base":"InventionsTable_base__QNd6B","missingData":"InventionsTable_missingData__G4CBG","dots":"InventionsTable_dots__Nek45","tooltip":"InventionsTable_tooltip__itzmr"};